import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';

const GuildContext = createContext(null);
const API = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = 'selected_guild_id';

export function GuildProvider({ children }) {
  const { user } = useAuth();
  const [guilds, setGuilds] = useState([]);
  const [selectedGuildId, setSelectedGuildId] = useState(() => localStorage.getItem(STORAGE_KEY) || null);
  const [loading, setLoading] = useState(true);

  const fetchGuilds = useCallback(async () => {
    if (!user) {
      setGuilds([]);
      setLoading(false);
      return;
    }
    try {
      const { data } = await axios.get(`${API}/api/my-guilds`);
      const list = data.guilds || [];
      setGuilds(list);
      setSelectedGuildId(prev => {
        if (prev && list.some(g => g.id === prev)) return prev;
        const fallback = list[0]?.id || null;
        if (fallback) localStorage.setItem(STORAGE_KEY, fallback);
        return fallback;
      });
    } catch {
      setGuilds([]);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { fetchGuilds(); }, [fetchGuilds]);

  const selectGuild = (guildId) => {
    setSelectedGuildId(guildId);
    localStorage.setItem(STORAGE_KEY, guildId);
  };

  const selectedGuild = guilds.find(g => g.id === selectedGuildId) || null;

  return (
    <GuildContext.Provider value={{ guilds, selectedGuildId, selectedGuild, selectGuild, loading, refetch: fetchGuilds }}>
      {children}
    </GuildContext.Provider>
  );
}

export const useGuild = () => useContext(GuildContext);
